module.exports = __webpack_public_path__ + "static/img/lunas.fe90ae0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/lunas.jpg
// module id = uH/D
// module chunks = 1